import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ProgressivePhoto from '../../ProgressivePhoto';
import { shouldUseForegroundThumbnails } from '../../../../util/photo';

const propTypes = {
  linkTo: PropTypes.string.isRequired,
  photo: PropTypes.shape({
    id: PropTypes.string,
    thumbnail_urls: PropTypes.array,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

const PhotoGridCard = ({ linkTo, photo, children }) => {
  const thumbnails = useMemo(
    () =>
      shouldUseForegroundThumbnails(photo)
        ? photo?.foreground?.thumbnail_urls
        : photo.thumbnail_urls,
    [photo?.id],
  );
  return (
    <div className="photo-grid-card">
      <Link to={linkTo}>
        <ProgressivePhoto
          thumbnails={thumbnails}
          allowFallbackThumbnail={shouldUseForegroundThumbnails(photo)}
        />
      </Link>
      {children}
    </div>
  );
};

PhotoGridCard.propTypes = propTypes;

export default PhotoGridCard;
